import { createSelector } from 'reselect';

import { selectPermissions } from '../user/selectors';

export const headerSelector = createSelector(
  [selectPermissions],
  ({
    showFeedbackHeaderItem,
    showHelpCenterHeaderItemFeatureFlag,
    showHelpCenterHeaderItemIfFeatureFlag,
    showNotificationsHeaderItemFeatureFlag,
    showNotificationsHeaderItemIfFeatureFlag,
  }) => ({
    showGiveFeedbackHeaderItem: showFeedbackHeaderItem,
    showHelpCenterHeaderItem:
      showHelpCenterHeaderItemFeatureFlag &&
      showHelpCenterHeaderItemIfFeatureFlag,
    showNotificationsHeaderItem:
      showNotificationsHeaderItemFeatureFlag &&
      showNotificationsHeaderItemIfFeatureFlag,
  })
);
